import { proxy } from 'valtio';

// reactive shared state between all portals
export const state = proxy({
  runFallback: false,
  useDeviceOrientation: false,
  openPortal: null,
  requestedVR: false, // immersive-vr session
  requestedAR: false, // immersive-ar session
  showDomOverlay: false,
  showInfoPanel: false,
  hasInteracted: false, // true if used has interacted with fallback controls
});

export const resetState = () => {
  state.runFallback = false;
  state.useDeviceOrientation = false;
  state.openPortal = null;
  state.requestedVR = false;
  state.requestedAR = false;
  state.showDomOverlay = false;
  state.showInfoPanel = false;
  state.hasInteracted = false;
};

let timer = null;
// Toggle DOM Overlay visibility
// Hide automatically after 3 seconds
export const toggleDomOverlay = visibility => {
  if (state.showInfoPanel) {
    // don't allow toggling when info panel is open
    return;
  }
  const newState = typeof visibility !== 'undefined' ? visibility : !state.showDomOverlay;
  state.showDomOverlay = newState;
  clearTimeout(timer);
  if (state.showDomOverlay) {
    timer = setTimeout(() => {
      if (!state.showInfoPanel) {
        state.showDomOverlay = false;
      }
    }, 3000);
  }
};
